<template>
  <button
    class="outline-button"
    :class="{ active }"
    @click="$emit('clicked'); $emit('click')"
  >
    <slot />
  </button>
</template>

<script>
  export default {
    props: {
      active: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/assets/sass/variables';

  .outline-button {
    border: 1px solid $buttonOutlineColor;
    color: $white300;
    background: transparent;
    padding: 8px 24px;
    font-size: 0.89rem;
    border-radius: 4px;
    transition: .5s all;

    &.active,
    &:hover {
      color: $highlightPrimaryColor;
      border-color: $highlightPrimaryColor;
    }
  }
</style>